import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'userSlice',
  initialState: {
    id: '',
    username: '',
    name: '',
    surname: '',
    expire: 3600,
    group: []
  },
  reducers: {
    setUserId: (state, action) => ({ ...state, id: action.payload }),
    setUserName: (state, action) => ({ ...state, username: action.payload }),
    setUserGroup: (state, action) => ({
      ...state,
      group: [action.payload]
    }),
    setExpire: (state, action) => ({ ...state, expire: action.payload }),
    removeUserName: (state, action) => {
      state.username = '';
      state.name = '';
      state.surname = '';
      state.expire = 3600;
      state.group = [];
    },
    setFullName: (state, action) => ({
      ...state,
      name: action.payload.name,
      surname: action.payload.surname
    }),
    removeFullName: (state, action) => ({
      ...state,
      name: '',
      surname: ''
    })
  }
});

export const {
  setUserId,
  setUserName,
  setUserGroup,
  setExpire,
  removeUserName,
  setFullName,
  removeFullName
} = userSlice.actions;
export default userSlice.reducer;
